module.exports = __webpack_public_path__ + "static/media/Icon - smart distributors.f2cbc22a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Icon - smart distributors.svg
// module id = 43
// module chunks = 0